import { useMutation } from "@tanstack/react-query";
import { Integration, IntegrationType, IntegrationStatus, TestConnectionResult } from "../../interfaces/DTO/agent/integration";
import { integrationService } from "../../services/integration/IntegrationService";
import { createCachedEntityHooks } from "../createEntityHooks";

// ✅ hook-ים גנריים עם cache לפי id
export const {
  useAll: useIntegrations,
  useEntityById: useIntegrationById,
  useEntityByIds: useIntegrationByIds,
  useCreateEntity: useCreateIntegration,
  useUpdateEntity: useUpdateIntegration,
  usePartialUpdateEntity: usePartialUpdateIntegration,
  useDeleteEntity: useDeleteIntegration,
} = createCachedEntityHooks<Integration & { id: number }>({
  entityName: "integrations",
  service: integrationService as any, // Type assertion כי Integration יש id אופציונלי
  enableCacheById: true,
  staleTimeMs: 60 * 60 * 1000, // 60 דקות - refresh רק אם היה שינוי או אם עבר זמן רב
});

/**
 * Hook לבדיקת חיבוריות אינטגרציה
 */
export function useTestIntegration() {
  return useMutation<TestConnectionResult, Error, number>({
    mutationFn: (integrationId: number) => integrationService.testIntegration(integrationId),
  });
}

/**
 * Hook לבדיקה אם יש אינטגרציית Google Email פעילה
 */
export function useHasActiveGoogleEmail() {
  const { data: integrations, isLoading } = useIntegrations();

  const hasActiveGoogleEmail = integrations?.some(
    (integration) =>
      integration.integration_type === IntegrationType.GOOGLE_EMAIL &&
      integration.status === IntegrationStatus.ACTIVE
  ) ?? false;

  return {
    hasActiveGoogleEmail,
    isLoading,
  };
}

/**
 * Hook לבדיקה אם יש אינטגרציית HubSpot פעילה
 */
export function useHasActiveHubspot() {
  const { data: integrations, isLoading } = useIntegrations();

  const hasActiveHubspot = integrations?.some(
    (integration) =>
      integration.integration_type === IntegrationType.HUBSPOT &&
      integration.status === IntegrationStatus.ACTIVE
  ) ?? false;

  return {
    hasActiveHubspot,
    isLoading,
  };
}

/**
 * Hook לבדיקה אם יש אינטגרציית Fireflies פעילה
 */
export function useHasActiveFireflies() {
  const { data: integrations, isLoading } = useIntegrations();

  const hasActiveFireflies = integrations?.some(
    (integration) =>
      integration.integration_type === IntegrationType.FIREFLIES &&
      integration.status === IntegrationStatus.ACTIVE
  ) ?? false;

  return {
    hasActiveFireflies,
    isLoading,
  };
}
